import axios from 'axios';

const validators = new Map<string, { etag: string; data: unknown }>();

/** Bounded cache of authorized probe responses, partitioned by URL and SaaS headers. */
export async function conditionalProbe(url: string, headers: Record<string, string>): Promise<unknown> {
  const key = JSON.stringify([url, Object.entries(headers).sort(([a], [b]) => a.localeCompare(b))]);
  const cached = validators.get(key);
  const response = await axios.get<unknown>(url, {
    headers: { ...headers, ...(cached ? { 'If-None-Match': cached.etag } : {}) },
    validateStatus: status => status === 200 || status === 304,
  });
  if (response.status === 304 && cached) return cached.data;
  const etag: unknown = response.headers?.etag;
  if (typeof etag === 'string') {
    if (validators.size >= 32) validators.delete(validators.keys().next().value as string);
    validators.set(key, { etag, data: response.data });
  }
  return response.data;
}
